import styled from 'styled-components';
import {
  Dropdown as BDropdown,
  DropdownToggle as BDropdownToggle,
  DropdownMenu as BDropdownMenu,
  DropdownItem as BDropdownItem,
} from 'reactstrap';
import media from 'styled-media-query';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 15px 20px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  position: relative;
  z-index: 1000;

  ${media.lessThan('medium')`
    align-items: flex-start;
    flex-direction: column;
    padding: 15px;
  `}
`;

export const Title = styled.h3`
  font-size: 24px;
  font-weight: 700;
  color: #0062cc;
  margin: 0;

  ${media.lessThan('medium')`
    margin-bottom: 15px;
    font-size: 20px;
  `}
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  position: relative;
  z-index: 1001;
  
  ${media.lessThan('medium')`
    width: 100%;
    justify-content: space-between;
  `}
`;

export const Dropdown = styled(BDropdown)`
  margin-left: 15px;
  position: static;
  
  &:first-child {
    margin-left: 0;
  }
  
  ${media.lessThan('medium')`
    margin-left: 10px;
  `}
`;

export const DropdownToggle = styled(BDropdownToggle)`
  border-radius: 12px;
  background: ${({ star }) => (star ? 'var(--primary)' : '#f0f2f5')};
  color: ${({ star }) => (star ? 'var(--white)' : '#4a5568')};
  border: none;
  box-shadow: none !important;
  transition: all ease 0.3s;
  padding: 10px 16px;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;

  &:hover,
  &:focus {
    background: ${({ star }) => (star ? '#0051a8' : '#e2e8f0')};
    color: ${({ star }) => (star ? 'var(--white)' : '#4a5568')};
  }

  svg {
    margin-left: 8px;
    font-size: 16px;
  }

  ${media.lessThan('medium')`
    font-size: 13px;
    padding: 8px 12px;
  `}
`;

export const DropdownMenu = styled(BDropdownMenu)`
  border: none;
  border-radius: 12px;
  padding: 8px;
  margin-top: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  min-width: 180px;
  z-index: 10000 !important;
  position: absolute !important;
  pointer-events: auto !important;
`;

export const DropdownItem = styled(BDropdownItem)`
  border-radius: 8px;
  padding: 10px 15px;
  margin-bottom: 2px;
  font-size: 14px;
  color: #4a5568;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #f0f2f5;
    color: var(--primary);
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`;
